import { SAVED_COURSES_TRANSLATION_KEY } from "../constants.js";
const translation = {
    [SAVED_COURSES_TRANSLATION_KEY]: {
        SC_BOOKMARK_REMOVED_COURSE: 'Course removed from "Saved Courses"',
        SC_BOOKMARK_ADDED_COURSE: 'Course saved in "Saved Courses"',
        SC_ERROR_SAVE_COURSE: "Error saving the course, please try again later",
        SC_ERROR_DELETE_COURSE: "Error deleting the course, please try again later"
    }
};
const en = translation;
export default en;
